import { view } from '@yola/ws-sdk';

const DEVICE_MODE_WIDTHS = {
  [view.deviceModes.DESKTOP]: null,
  [view.deviceModes.TABLET]: 1024,
  [view.deviceModes.MOBILE]: 360,
};

export default DEVICE_MODE_WIDTHS;
